import { RecordingsService } from 'app/modules/selection-generic/services/recordings.service';
import { ResponseStatus } from 'app/modules/common/enums/common-enums';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DocumentsService } from '../services/documents.service';
import { Subscription, pipe, from } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from '@angular/material/dialog';
import _ from 'lodash';
import { AddDocumentComponent } from '../documentos/add-document/add-document.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentViewContainerComponent } from './document-view-container/document-view-container.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { ActuationService } from '../services/actuation.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import { ActuationOperation as ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import { SharedService } from 'app/modules/common/services/shared-service';
import Utils from 'app/Utils';

@Component({
    selector: 'app-documentos',
    templateUrl: './documentos.component.html',
    styleUrls: ['./documentos.component.scss'],
    standalone: false
})
export class DocumentosComponent implements OnInit, OnDestroy {
    ShowEmployeeOptionButton: boolean;

    ShowLeaveDocumentDeleteOption: boolean;

    actuationOperation = ActuationOperation;
    isLoading = false;

    constructor(
        public dialog: MatDialog,
        public snackBar: MatSnackBar,
        public router: Router,
        public sanitizer: DomSanitizer,
        public documentService: DocumentsService,
        public actuationService: ActuationService,
        public leaveService: LeaveService,
        public sharedService: SharedService,
        private recordingsService: RecordingsService,
    ) {}

    ngOnInit() {
        this.documentService.SubcribeDocuments();
        this.GetEmployeeDocumentOptionPermission();
        this.GetLeaveDocumentDeleteOptionVisibility();
        this.actuationService.SubcribeActuations();
    }

    ngOnDestroy() {
        this.documentService.Unsubscribe();
        this.actuationService.Unsubscribe();
    }

    OnEmployeeDocumentClick() {
        const dialogRef = this.dialog.open(AddDocumentComponent, {
            width: '400px',
        });
        dialogRef.afterClosed().subscribe((_) => {});
    }

    private GetEmployeeDocumentOptionPermission() {
        const permissions: Array<string> = Utils.decrypt(localStorage
            .getItem('permissionIds'))
            .split(',');
        this.ShowEmployeeOptionButton = this.sharedService.Permissions
            .HasPermisos311
            ? true
            : false;
    }

    public CreateDownloadableDocument(doc) {
        const base64string: string = doc.Document;
        const docType: string = doc.DocumentType;
        var link = document.createElement('a');
        link.innerHTML = 'Descargar';

        if (docType === 'PDF') {
            link.download = 'file.pdf';
            link.href = 'data:application/octet-stream;base64,' + base64string;
        } else if (docType === 'DOC') {
        } else if (docType === 'PNG') {
        }
        document.getElementById(doc.DocumentoId).appendChild(link);
    }

    public GetHref(doc) {
        const base64string: string = doc.Document;
        return 'data:application/octet-stream;base64,' + base64string;
    }

    public GetDocName(doc) {
        return `TBX${doc.DocumentoId}.${doc.DocumentType.toLowerCase()}`;
    }

    public DeleteDocument(doc: { DocumentoId: string }) {
        this.isLoading = true; 
        let deleteObject: any = doc;
        const documents = this.documentService.documentsSubjects.getValue();
        const docId = doc.DocumentoId;
        const matchingActuation = documents.find(
            (actuation) => String(actuation.documentoId) === docId
        );
    
        if (deleteObject.GrabacionId) {
            this.recordingsService.isMatching = false;
            this.recordingsService.deleteRecordings(Number(deleteObject.GrabacionId)).subscribe(
                (res) => {
                    if (res.code == ResponseStatus.Success && res.result) {
                        this.sharedService.ShowSnackBar(
                            'La grabación se ha eliminado'
                        );
                        this.documentService.PublishDocuments(
                            Number(localStorage.getItem('EmplooyeeID'))
                        );
                    } else {
                        this.sharedService.ShowSnackBar(
                            'Error al eliminar la grabación'
                        );
                    }
                    this.isLoading = false; 
                },
                (error) => {
                    console.error(error);
                    this.sharedService.ShowSnackBar(
                        'Error al eliminar la grabación'
                    );
                }
            );
        } else {
            const actuacionId = matchingActuation ? matchingActuation.actuacionID : null;
            this.documentService.deleteEmployeeDocument(doc.DocumentoId, actuacionId ).subscribe(
                (res) => {
                    this.ShowSnackBar('Borrado exitosamente', '', 2500);
                    this.documentService.PublishDocuments(
                        Number(localStorage.getItem('EmplooyeeID'))
                    );
                },
                (err) => {
                    console.error(err);
                    this.sharedService.ShowSnackBar('Error al eliminar el documento');
                    this.isLoading = false; 
                }
            );
        }
    }

    public ViewDocument(doc) {
        const dialogRef = this.dialog.open(DocumentViewContainerComponent, {
            data: { EmployeeDocId: doc.DocumentoId, Type: '1' },width: '70vw',
        });
        dialogRef.afterClosed().subscribe((_) => {});
        document.querySelectorAll('.hiddenCanvasElement').forEach(e => e.remove());
    }

    public ShowSnackBar(message: string, action: string, duration: number) {
        return this.snackBar.open(message, action, {
            duration: duration,
        });
    }

    //Leave documents.

    public ViewLeaveDocument(documetData) {
        let documentId: number = null;
        let type: number = null;
        if (documetData.DocumentoId !== null) {
            documentId = documetData.DocumentoId;
            type = 2;
        } else if (documetData.GrabacionId !== null) {
            documentId = documetData.GrabacionId;
            type = 3;
        }
        const dialogRef = this.dialog.open(DocumentViewContainerComponent, {
            data: { EmployeeDocId: documentId, Type: type },width: '70vw',
        });
        dialogRef.afterClosed().subscribe((_) => {});
        document.querySelectorAll('.hiddenCanvasElement').forEach(e => e.remove())
    }

    private GetLeaveDocumentDeleteOptionVisibility() {
        const permissions = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
        this.ShowLeaveDocumentDeleteOption = permissions.includes('521')
            ? false
            : true;
    }

    public DeleteRecording(documetData) {
        this.documentService.deleteRecording(documetData.GrabacionId).subscribe(
            (res) => {
                this.ShowSnackBar('Borrado exitosamente', '', 2500);
                this.documentService.PublishDocuments(
                    Number(localStorage.getItem('EmplooyeeID'))
                );
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public GetLeaveDocName(documetData) {
        let docId: number = null;
        let docType: string = null;
        if (!documetData.GrabacionId) {
            docId = documetData.DocumentoId;
            docType = 'PDF';
        } else if (!documetData.DocumentoId) {
            docId = documetData.GrabacionId;
            docType = 'MP3';
        }
        return `TBX${docId}.${docType.toLowerCase()}`;
    }

    public GetLeaveDocumentHref(documetData) {
        let base64string: string = null;
        if (documetData.GrabacionId === null) {
            base64string = documetData.Document;
            return 'data:application/octet-stream;base64,' + base64string;
        } else if (documetData.DocumentoId === null) {
            base64string = documetData.Recording;
            return 'data:audio/wav;base64,' + base64string;
        }
    }

    confirmDialog(doc: { DocumentoId: string }): void {
        const message = `¿Seguro que quieres hacer esto?`;

        const dialogData = new ConfirmDialogModel('Confirmar acción', message);

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.DeleteDocument(doc);
            }
        });
    }

    /**
     * Delete a document by ID
     */
    deleteDocumentById(documentId: number) {
        this.confirmDialog({ DocumentoId: documentId.toString() });
    }
}
